import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
	root: {
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		gap: '8px',
	},
	fieldRoot: {
		width: '100%'
	},
	dropdownRoot: {
		width: '100%',
	},
	dropdown: {
		width: '100%',
		minWidth: '120px',
		border: `1px solid ${tokens.colorNeutralStroke1}`,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		'::after': {
			borderBottom: 'none'
		},
		':hover': {
			background: tokens.colorNeutralBackground4Hover,
			border: `1px solid ${tokens.colorNeutralStroke1Hover}`
		},
		':active': {
			background: tokens.colorNeutralBackground4Hover,
			border: `1px solid ${tokens.colorNeutralStroke1Hover}`
		}
	},
	input: {
		width: '100%',
		border: `1px solid ${tokens.colorNeutralStroke1}`,
		outline: 'none',
		'::after': {
			borderBottom: 'none',
			height: 0,
		},
		':hover': {
			background: tokens.colorNeutralBackground4Hover,
			border: `1px solid ${tokens.colorNeutralStroke1Hover}`
		},
		':focus-within': {
			background: tokens.colorNeutralBackground4Hover,
			border: `1px solid ${tokens.colorNeutralStroke1}`,
			borderBottomColor: `${tokens.colorNeutralStroke1}!important`,
			borderTopColor: `${tokens.colorNeutralStroke1}!important`,
			borderRightColor: `${tokens.colorNeutralStroke1}!important`,
			borderLeftColor: `${tokens.colorNeutralStroke1}!important`,
		},
	},
	skeletonRoot: {
		padding: '0px',
	},
	skeletonItem: {
		height: '32px',
		backgroundColor: tokens.colorNeutralBackground5,
		':after': {
			backgroundImage: `linear-gradient(to right, ${tokens.colorNeutralBackground5} 0%, ${tokens.colorNeutralBackground2} 50%, ${tokens.colorNeutralBackground5} 100%)`
		}
	}
});